import {priority} from '@priority-software/priority-proto-api/lib';

export enum RuleType {
    business = priority.netitems.form.RuleType.Business,
    autofill = priority.netitems.form.RuleType.AutoFill,
    macro = 3,
    bpm = 111,
    empty = -1
}

export enum RuleFilters {
    ruleAction = 'ruleAction',
    validFor = 'validFor',
    updatedBy = 'updatedBy',
    isActive = 'isActive'
}

export enum AlertMessageFields {
    'Subject' = 'Subject',
    'Message' = 'Message',
    'Language' = 'Language'
}

export enum AlertConditionFields {
    'CurrentValue' = 'CurrentValue',
    'ConditionOperator' = 'ConditionOperator',
    'ConditionField' = 'ConditionField',
    'ConditionValue' = 'ConditionValue',
    'ConditionSecondValue' = 'ConditionSecondValue'
}

export enum AlertFormFields {
    'ValidUser' = 'ValidUser',
    'ValidGroup' = 'ValidGroup',
    'ValidAllUsers' = 'ValidAllUsers',
    'ValidMySelf' = 'ValidMySelf',
    'ValidUserInGroup' = 'ValidUserInGroup',
    'UpdateField' = 'UpdateField',
    'MultiComp' = 'MultiComp'
}

export enum AlertFields {
    'AlertNumber' = 'AlertNumber',
    'Messages' = 'Messages',
    'Document' = 'Document',
    'DocumentFormat' = 'DocumentFormat',
    'DocumentFormatLang' = 'DocumentFormatLang',
    'Description' = 'Description',
    'MessageType' = 'MessageType',
    'MailType' = 'MailType',
    'Active' = 'Active',
    'WebHook' = 'WebHook',
    'RecipientUser' = 'RecipientUser',
    'RecipientGroup' = 'RecipientGroup',
    'RecipientField' = 'RecipientField',
    'RecipientMail' = 'RecipientMail',
    'BPM' = 'BPM',
    'Form' = 'Form',
    'AlertConds' = 'AlertConds',
    'Pdf' = 'Pdf',
    'ExtFile' = 'ExtFile',
    'WordTemplates' = 'WordTemplates',
    'ConditionsOperator' = 'ConditionsOperator',
    'CoverLetters' = 'CoverLetters'
}

export enum AutomationTypeNames {
    'Business' = 'ALERTSREPORT',
    'AutoFill' = 'ALERTSREPORTB'
}

export enum ChatboxSpecialCategory {
    only = 'only'
}

export enum AlertValidForCategory {
    user = 370,
    userInGroup = 371,
    group = 372
}

export enum AlertPermission {
    user = 1,
    admin = 2
}
